/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OpportunityBreakdown } from "./OpportunityBreakdown";
import {
  OpportunityBreakdownFromJSON,
  OpportunityBreakdownFromJSONTyped,
  OpportunityBreakdownToJSON,
  OpportunityBreakdownToJSONTyped,
} from "./OpportunityBreakdown";

/**
 *
 * @export
 * @interface OpportunityFreightProfile
 */
export interface OpportunityFreightProfile {
  /**
   *
   * @type {number}
   * @memberof OpportunityFreightProfile
   */
  averageWeightPounds?: number;
  /**
   *
   * @type {number}
   * @memberof OpportunityFreightProfile
   */
  averageHandlingUnits?: number;
  /**
   *
   * @type {number}
   * @memberof OpportunityFreightProfile
   */
  averageLinearFeet?: number;
  /**
   *
   * @type {Array<OpportunityBreakdown>}
   * @memberof OpportunityFreightProfile
   */
  accessorials: Array<OpportunityBreakdown>;
}

/**
 * Check if a given object implements the OpportunityFreightProfile interface.
 */
export function instanceOfOpportunityFreightProfile(
  value: object,
): value is OpportunityFreightProfile {
  if (!("accessorials" in value) || value["accessorials"] === undefined)
    return false;
  return true;
}

export function OpportunityFreightProfileFromJSON(
  json: any,
): OpportunityFreightProfile {
  return OpportunityFreightProfileFromJSONTyped(json, false);
}

export function OpportunityFreightProfileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OpportunityFreightProfile {
  if (json == null) {
    return json;
  }
  return {
    averageWeightPounds:
      json["averageWeightPounds"] == null
        ? undefined
        : json["averageWeightPounds"],
    averageHandlingUnits:
      json["averageHandlingUnits"] == null
        ? undefined
        : json["averageHandlingUnits"],
    averageLinearFeet:
      json["averageLinearFeet"] == null ? undefined : json["averageLinearFeet"],
    accessorials: (json["accessorials"] as Array<any>).map(
      OpportunityBreakdownFromJSON,
    ),
  };
}

export function OpportunityFreightProfileToJSON(
  json: any,
): OpportunityFreightProfile {
  return OpportunityFreightProfileToJSONTyped(json, false);
}

export function OpportunityFreightProfileToJSONTyped(
  value?: OpportunityFreightProfile | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    averageWeightPounds: value["averageWeightPounds"],
    averageHandlingUnits: value["averageHandlingUnits"],
    averageLinearFeet: value["averageLinearFeet"],
    accessorials: (value["accessorials"] as Array<any>).map(
      OpportunityBreakdownToJSON,
    ),
  };
}
